import React from 'react';
import { Form } from 'formik';
import { FormikField } from '../../../../components/FormikField';
import { Divider } from 'primereact/divider';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from './TechnicalFailureForm.styles.scss';
import cn from 'classnames';

const TechnicalFailureForm = ({
  values,
  errors,
  touched,
  formConfig,
  submitLabel,
  cancelLabel,
  loading,
  readOnly = false,
}) => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();

  return (
    <Form className={styles.failureForm}>
      {formConfig.map((section, index) => (
        <div className={index === 0 ? 'mb-5' : ''} key={section.title}>
          <h2>{section.title}</h2>
          <div className={styles.formSection}>
            {section.fields
              .filter((item) => !item.hide)
              .map((field) => (
                <div key={field.name} className={styles.fieldWrapper}>
                  <FormikField
                    {...field}
                    name={field.name}
                    component={field.component}
                    error={errors[field.name]}
                    componentProps={{
                      ...field.componentProps,
                      className: cn(
                        field.componentProps?.className,
                        !values[field.name] ? styles.emptyField : '',
                        errors[field.name] && touched[field.name]
                          ? styles.errorField
                          : '',
                      ),
                    }}
                  />
                </div>
              ))}
          </div>
        </div>
      ))}
      <Divider className="my-4" />
      <div className={styles.formActions}>
        <Button
          label={cancelLabel}
          outlined
          size="medium"
          className={styles.formBtn}
          type="button"
          onClick={() =>
            navigate(
              `/${i18n.language}/additional-functionalities/failure-notification`,
            )
          }
        />
        {!readOnly && (
          <Button
            type="submit"
            size="medium"
            className={styles.formBtn}
            label={submitLabel}
            loading={loading}
            disabled={Object.keys(errors).length > 0 || loading}
          />
        )}
      </div>
    </Form>
  );
};

export default TechnicalFailureForm;
